<template>
  <v-layout>
    <v-dialog v-model="dialog" persistent max-width="500">
      <v-card>
        <v-card-title>
          <span class="headline">Kommentar erstellen</span>
        </v-card-title>
        <v-card-text>
          <v-row>

            <v-col cols="12" align="start">
              Bitte geben Sie hier Ihren Kommentar ein
            </v-col>
            <v-col cols="12" xs="12" md="6" align="center">
              <v-select
                  outlined
                  v-model="item.action"
                  :items="actioNames"
                  item-text="text"
                  item-value="value"
                  label="Aktion"
              >
              </v-select>

            </v-col>
            <v-col cols="12" xs="12" >
              <v-text-field v-model="item.comment" label="Kommentar"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="dialog=false" small class="text-none">Abbrechen
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="createItem()" color="primary" small dark class="text-none">
            Erstellen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'DialogCreateComment',
  components: {},
  methods: {
    open: function () {
      this.dialog = true
      this.item = {
        comment: '',
        action: 'manual',
        extra: null
      }
    },
    createItem: function () {
      this.dialog = false
      this.$emit('createItem', this.item)
    }
  },
  data() {
    return {
      dialog: false,
      mailTemplate: null,
      actioNames: [{
        value: 'manual',
        text: 'Default'
      },{
        value: 'phone',
        text: 'Telefonat'
      },{
        value: 'mail',
        text: 'E-mail'
      },{
        value: 'contact',
        text: 'Kontakt'
      }],
      item: {
        comment: '',
        extra: null
      }
    }
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
